import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=67f9a545&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f9a545')) {
      api.createRecord('67f9a545', component.options)
    } else {
      api.reload('67f9a545', component.options)
    }
    module.hot.accept("./DefaultLayout.vue?vue&type=template&id=67f9a545&", function () {
      api.rerender('67f9a545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/DefaultLayout.vue"
export default component.exports